import SectionSkeleton from "../../../../components/ui/SectionSkeleton"
import { Button, Typography } from "@mui/material"
import { Fragment, lazy, Suspense } from "react"

const CtaSection = lazy(() => import("../../../../components/ui/CtaSection"))
const AllCourses = lazy(() => import("./AllCourses"))
const TopBanner = lazy(() => import("./TopBanner"))

function Courses() {
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBanner />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <AllCourses />
      </Suspense>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography
            variant="ctaNormal"
          >Empower Yourself – Start a Course Now
          </Typography>
          <Button
            variant="CtaButton"
          >Start Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  )
}

export default Courses